// This file is auto-generated by @hey-api/openapi-ts

/**
 * Default valid to when setting this profile.
 */
export const CustomerProfileValidToDefaultsEnum = {
    CARD_VALIDITY: 'CARD_VALIDITY',
    END_OF_YEAR: 'END_OF_YEAR',
    END_OF_JANUARY: 'END_OF_JANUARY',
    END_OF_AUGUST: 'END_OF_AUGUST',
    DAY_BEFORE_19_BIRTHDAY_OR_END_OF_AUGUST: 'DAY_BEFORE_19_BIRTHDAY_OR_END_OF_AUGUST',
    TO_AGE: 'TO_AGE',
    '365_DAYS_AFTER_CONFIRMATION_DELIVERY': '365_DAYS_AFTER_CONFIRMATION_DELIVERY',
    '430_DAYS_AFTER_CONFIRMATION_DELIVERY': '430_DAYS_AFTER_CONFIRMATION_DELIVERY',
    END_OF_SEPTEMBER: 'END_OF_SEPTEMBER',
    TO_DEFINED_YEARS: 'TO_DEFINED_YEARS'
} as const;

/**
 * Default valid to when setting this profile.
 */
export type CustomerProfileValidToDefaultsEnum = typeof CustomerProfileValidToDefaultsEnum[keyof typeof CustomerProfileValidToDefaultsEnum];
